import React, {createContext, useContext} from 'react'
import {ICorrespondenceHost} from './types'
import {internalHost} from './internalHost'

/**
 * Default to internalHost so shell-level components (CorrespondenceBell,
 * useCorrespondenceNotifier) that live above any route boundary continue to
 * work without an explicit provider.  Financier (and future) routes override
 * this by mounting their own CorrespondenceHostProvider.
 */
const CorrespondenceHostContext = createContext<ICorrespondenceHost>(internalHost)

interface Props {
  host: ICorrespondenceHost
  children: React.ReactNode
}

export const CorrespondenceHostProvider: React.FC<Props> = ({host, children}) => (
  <CorrespondenceHostContext.Provider value={host}>{children}</CorrespondenceHostContext.Provider>
)

/** Returns the nearest host adapter — internalHost by default. */
export function useCorrespondenceHost(): ICorrespondenceHost {
  return useContext(CorrespondenceHostContext)
}
